import styled from "styled-components";

import { Calendar } from "react-big-calendar";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";

export const CalendarScheduleSection = styled.div.attrs({
  className: "athspire-calendar__toolbar",
})``;

export const CalendarScheduleSectionSecondary = styled.div.attrs({
  className: "athspire-calendar__toolbar-copy",
})``;

export const CalendarScheduleInlineText = styled.span.attrs({
  className: "athspire-calendar__toolbar-kicker",
})``;

export const CalendarScheduleSectionTertiary = styled.div.attrs({
  className: "athspire-calendar__toolbar-meta",
})``;

export const CalendarScheduleTextBlock = styled.p.attrs({
  className: "athspire-calendar__toolbar-label",
})``;

export const CalendarScheduleTextBlockSecondary = styled.p.attrs({
  className: "athspire-calendar__toolbar-date",
})``;

export const CalendarScheduleSectionQuaternary = styled.div.attrs({
  className: "athspire-calendar__toolbar-actions",
})``;

export const CalendarScheduleSectionQuinary = styled.div.attrs({
  className: "athspire-calendar__toolbar-group",
})``;

export const CalendarScheduleToolbarNav = styled.div.attrs({
  className: "athspire-calendar__toolbar-nav",
})``;

export const CalendarScheduleToolbarViews = styled.div.attrs({
  className: "athspire-calendar__toolbar-views",
})``;

export const CalendarScheduleGridLayout = styled.div.attrs({ className: "grid gap-4" })``;

export const CalendarScheduleSidebar = styled.div.attrs({
  className: "grid gap-4 xl:sticky xl:top-6",
})``;

export const CalendarScheduleStatsStrip = styled.div.attrs({
  className: "grid grid-cols-2 gap-2 sm:grid-cols-4",
})``;

export const CalendarScheduleStatCard = styled.div.attrs({
  className:
    "rounded-xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3 py-2.5",
})``;

export const CalendarScheduleStatLabel = styled.p.attrs({
  className: "text-[11px] font-medium uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;

export const CalendarScheduleStatValue = styled.p.attrs({
  className: "mt-1 text-xl font-semibold tabular-nums leading-none text-[var(--brand-ink)]",
})``;

export const CalendarScheduleGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2 xl:grid-cols-4",
})``;

export const CalendarScheduleSectionSenary = styled.div.attrs({
  className:
    "relative overflow-hidden rounded-[24px] border border-transparent bg-[rgba(33,38,46,0.96)] px-5 py-4",
})``;

export const CalendarScheduleEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.24em] text-[var(--brand-highlight)]",
})``;

export const CalendarScheduleBodyText = styled.p.attrs({
  className: "font-display mt-3 text-[2rem] font-semibold leading-none text-[var(--brand-ink)]",
})``;

export const CalendarScheduleBodyTextSecondary = styled.p.attrs({
  className: "mt-2.5 text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const CalendarScheduleGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-5 xl:grid-cols-[minmax(0,1.22fr)_380px] xl:items-start",
})``;

export const CalendarScheduleMediaSurface = styled.div.attrs({
  className: "relative overflow-hidden rounded-[28px] bg-[rgba(27,32,40,0.98)] p-4",
})``;

export const CalendarScheduleCalendar = styled(Calendar).attrs({ className: "athspire-calendar" })``;

export const CalendarScheduleInfoRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2",
})``;

export const CalendarScheduleTitleText = styled.p.attrs({
  className: "mt-3 text-[1.35rem] font-semibold leading-tight text-[var(--brand-ink)]",
})``;

export const CalendarScheduleMetaList = styled.div.attrs({
  className: "mt-4 grid gap-2",
})``;

export const CalendarScheduleMetaRow = styled.div.attrs({
  className: "flex items-start gap-2.5 text-sm text-[var(--brand-ink)]",
})``;

export const CalendarScheduleGridLayoutQuaternary = styled.div.attrs({
  className: "mt-4 grid gap-3",
})``;

export const CalendarSchedulePanelCard = styled.div.attrs({
  className:
    "flex items-start gap-3 rounded-[20px] border border-transparent bg-[rgba(255,255,255,0.04)] px-4 py-3.5 backdrop-blur-sm",
})``;

export const CalendarScheduleFaClock = styled(FaClock).attrs({
  className: "mt-0.5 shrink-0 text-[var(--brand-highlight)]",
})``;

export const CalendarScheduleTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const CalendarScheduleEyebrowTextSecondary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const CalendarScheduleBodyTextTertiary = styled.p.attrs({
  className: "mt-1 text-sm font-medium leading-6 text-[var(--brand-ink)]",
})``;

export const CalendarScheduleFaMapMarkerAlt = styled(FaMapMarkerAlt).attrs({
  className: "mt-0.5 shrink-0 text-[var(--brand-highlight)]",
})``;

export const CalendarScheduleBodyTextQuaternary = styled.p.attrs({
  className: "mt-1 break-words text-sm font-medium leading-6 text-[var(--brand-ink)]",
})``;

export const CalendarScheduleBodyTextQuinary = styled.p.attrs({
  className: "mt-4 text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const CalendarScheduleActionLink = styled.a.attrs({
  className:
    "mt-5 inline-flex items-center gap-2 rounded-full bg-[var(--brand-highlight)] px-4 py-2.5 text-sm font-semibold text-[#1b1306] transition hover:-translate-y-0.5 hover:bg-[var(--brand-accent-deep)] hover:text-white",
})``;

export const CalendarScheduleHeaderRow = styled.div.attrs({
  className: "flex items-start justify-between gap-3",
})``;

export const CalendarScheduleEyebrowTextTertiary = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const CalendarScheduleFaCalendarAlt = styled(FaCalendarAlt).attrs({
  className: "text-[var(--brand-highlight)]",
})``;

export const CalendarScheduleSectionSeptenary = styled.div.attrs({
  className: "flex items-start justify-between gap-3",
})``;

export const CalendarScheduleTextBlockTertiary = styled.p.attrs({
  className: "break-words text-sm font-semibold leading-6 text-[var(--brand-ink)]",
})``;

export const CalendarScheduleBodyTextSenary = styled.p.attrs({
  className: "mt-1 text-[12px] leading-5 text-[var(--brand-muted)]",
})``;

export const CalendarScheduleBodyTextSeptenary = styled.p.attrs({
  className: "mt-2 break-words text-[12px] leading-5 text-[var(--brand-muted)]",
})``;

export const CalendarScheduleCategoryHint = styled.span.attrs({
  className: "text-[11px] font-medium uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const CalendarScheduleStatusHint = styled.span.attrs({
  className: "text-[11px] font-medium tracking-[0.02em] text-[var(--brand-muted)]",
})``;

export const CalendarScheduleDetailsLabel = styled.p.attrs({
  className: "text-[11px] font-medium uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;
